// src/pages/ProfilePage.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import ProfileHeader from '../components/profile-components/ProfileHeader';
import { DailyMessageBanner } from '../components/profile-components/DailyMessageBanner';
import { FavoriteProductsList } from '../components/profile-components/FavoriteProductList';
import { WatchedHistoryList } from '../components/profile-components/WatchedHistoryList';
import { PurchasedProductsList } from '../components/profile-components/PurchasedProductsList';
import { useAuthContext } from '../context/AuthContext';
import ChargeRequestModal from '../components/wallet/ChargeRequestModal';

function ProfilePage() {
  const { handleLogout, isLoggedIn, openAuthModal } = useAuthContext();
  const [isChargeModalOpen, setIsChargeModalOpen] = useState(false);

  // 🟢 باز کردن مودال در صورت لاگین نبودن کاربر
  useEffect(() => {
    if (!isLoggedIn) {
      openAuthModal();
    }
  }, [isLoggedIn, openAuthModal]);

  // 🟢 تا زمانی که کاربر لاگین نکرده، هیچ چیز رندر نکن (جلوی API های ۴۰۱ را می‌گیرد)
  if (!isLoggedIn) {
    return null;
  }

  const ProfileMenu = () => (
    <div className="space-y-3">
      <h3 className="text-gray-600 font-semibold mt-8 mb-3 border-b pb-2">تنظیمات حساب</h3>
      <Link to="/profile/edit" className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition">
        <span className="text-[12px] text-gray-800 font-medium">✍️ ویرایش اطلاعات کاربری</span>
        <span className="text-gray-400">{'<'}</span>
      </Link>
      <Link to="/profile/volunteer" className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition">
        <span className="text-[12px] text-gray-800 font-medium">🤝 درخواست همکاری داوطلبانه</span>
        <span className="text-gray-400">{'<'}</span>
      </Link>
      <Link to="/profile/donate" className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition">
        <span className="text-[12px] text-gray-800 font-medium">کمک مالی به توسعه‌یِ اپلیکیشن فرزانه</span>
        <span className="text-gray-400">{'<'}</span>
      </Link>
      <Link to="/profile/rules" className="flex items-center justify-between p-4 bg-white rounded-lg shadow-sm hover:bg-gray-50 transition">
        <span className="text-[12px] text-gray-800 font-medium">📜 چارچوب اخلاقی و قوانین</span>
        <span className="text-gray-400">{'<'}</span>
      </Link>
      <button onClick={handleLogout} className="w-full text-gray-700 font-bold mt-6 p-3 bg-gray-100 rounded-lg hover:bg-gray-200 transition">
        🚪 خروج از حساب کاربری
      </button>
    </div>
  );

  // بنر تبلیغاتی با قابلیت کلیک (باز کردن مدال شارژ در صورت لاگین بودن، در غیر این صورت مودال ورود)
  const BannerImage = () => {
    const bannerUrl = 'https://s3.afra.kubit.cloud/mahsacanva1365-far-free/profile/5.png';
    const handleClick = () => {
      if (!isLoggedIn) {
        openAuthModal();
      } else {
        setIsChargeModalOpen(true);
      }
    };
    return (
      <div className="my-6 w-full cursor-pointer" onClick={handleClick}>
        <img src={bannerUrl} alt="درخواست شارژ کیف پول" className="w-full rounded-xl shadow-md object-cover" loading="lazy" />
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <ProfileHeader />
      <div className="px-4 mx-auto -mt-10 relative z-5">
        <DailyMessageBanner />
      </div>
      <div className="p-4 pt-6">
        <PurchasedProductsList />
        <BannerImage />
        <FavoriteProductsList />
        <div className="mt-8">
          <WatchedHistoryList />
        </div>
        <ProfileMenu />
      </div>
      <ChargeRequestModal isOpen={isChargeModalOpen} onClose={() => setIsChargeModalOpen(false)} />
    </div>
  );
}

export default ProfilePage;